<template>
  <!--登录信息开始-->
  <div class="login-info">
    <!--头部开始-->
    <header class="head">
      <slot name="goBack">
        <a class="left clearfix" href="javascript: void(0)" @click="goBackFn">
          <i class="icon-left-arrow"></i>
        </a>
      </slot>

      <div class="right clearfix">
        <span class="income" title="收入功能正在研发中~">我的收入：0</span>

        <img class="head-pic" :src="`/static/img/${loginInfo.headPic}.png`" alt="头像"/>

        <span class="head-name">{{ loginInfo.userNmae }}</span>

        <a class="handle" href="javascript: void(0)" @click="handleShowFn">
          <i class="icon icon-login-handle"></i>
        </a>
      </div>

      <transition name="move">
        <div class="login-handle" v-show="loginFlag">
          <ul class="login-handle-box" onselectstart="return false">
            <li>
              <a class="item clearfix" href="javascript: void(0)" @click="logoutFn">注销</a>
            </li>
          </ul>

          <a class="close" @click="handleHiddenFn">
            <i class="btn icon-cancel-circle"></i>
          </a>
        </div>
      </transition>
    </header>
    <!--头部结束-->

    <!--加载提示层-->
    <v-loading :show="loading"></v-loading>
  </div>
  <!--登录信息结束-->
</template>

<script type="text/ecmascript-6">
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'
  // lading 加载组件
  import loading from 'components/loading/loading'

  export default {
    name: 'loginInfo',
    data () {
      return {
        // 加载提示层
        loading: false,
        // 登录后的操作弹出层标志
        loginFlag: false,
        // 用户登录后记录 cookie 信息
        loginInfo: {
          userNmae: VueCookie.get('UserName'),
          userId: VueCookie.get('UserID'),
          sessionId: VueCookie.get('SessionID'),
          headPic: VueCookie.get('HeadPictrueUrl')
        }
      }
    },
    mounted () {
      // axios 前置拦截器
      Axios.interceptors.request.use(config => {
        // 显示 loading 提示层
        this.loading = true
        return config
      })
      // axios 后置拦截器
      Axios.interceptors.response.use(response => {
        // 关闭 loading 提示层
        this.loading = false
        return response
      })
    },
    methods: {
      goBackFn () {
        this.$router.go(-1)
      },
      // 登出
      logoutFn () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('UserID', this.loginInfo.userId)
        // 将密码添加到表单
        formData.append('SessionID', this.loginInfo.sessionId)

        Axios.post(`${this.$api.root}/account/New_LogOff`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            // 结果匹配
            switch (res.Code) {
              // 请求成功
              case 0:
                // 删除 cookie 信息
                delUserCookie()
                // 跳转到个人主页
                this.$router.push({path: '/login'})
                break
              // 如果出现其他错误，强制退出
              default:
                // 删除 cookie 信息
                delUserCookie()
                // 跳转到个人主页
                this.$router.push({path: '/login'})
            }
          }
        // 请求接口失败
        }).catch((error) => {
          console.log(error)
        })
      },
      // 显示操作弹出层
      handleShowFn () {
        this.loginFlag = true
      },
      // 关闭操作弹出层
      handleHiddenFn () {
        this.loginFlag = false
      }
    },
    components: {
      'v-loading': loading
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "loginInfo.styl";
</style>



// WEBPACK FOOTER //
// src/components/loginInfo/loginInfo.vue